import { render, staticRenderFns } from "./AppTag.vue?vue&type=template&id=5ebb4c06&"
import script from "./AppTag.vue?vue&type=script&lang=js&"
export * from "./AppTag.vue?vue&type=script&lang=js&"
import style0 from "./AppTag.vue?vue&type=style&index=0&id=5ebb4c06&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports